exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".teacher__menu[data-v-47c97e52]{width:100%}.trainer__flash[data-v-47c97e52]{min-width:400px;box-sizing:border-box;height:100%}@media (max-width:640px){.trainer__flash[data-v-47c97e52]{min-width:300px}}", ""]);

// exports
